/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MortalityRequest } from '../../models/mortality-request';
import { MortalityTableRow } from '../../models/mortality-table-row';

export interface PutMortality$Params {
  harvestId: number;
  groupIdx?: number;
      body: Array<MortalityRequest>
}

export function putMortality(http: HttpClient, rootUrl: string, params: PutMortality$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MortalityTableRow>>> {
  const rb = new RequestBuilder(rootUrl, putMortality.PATH, 'put');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.query('groupIdx', params.groupIdx, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MortalityTableRow>>;
    })
  );
}

putMortality.PATH = '/api/harvests/{harvestId}/mortality';
